import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useWorkspace } from '../contexts/WorkspaceContext'
import { Icon } from '@iconify/react'

export default function FaturaDetalhes() {
  const { paymentId } = useParams()
  const { currentWorkspace } = useWorkspace()
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')
  const [payment, setPayment] = useState(null)
  const [pix, setPix] = useState(null)

  useEffect(() => {
    const run = async () => {
      try {
        if (!currentWorkspace?.id) return
        setLoading(true)

        const urlBase = '/api/asaas'
        const q = `?workspace_id=${currentWorkspace.id}&payment_id=${paymentId}`

        const [resPay, resPix] = await Promise.all([
          fetch(`${urlBase}/payment-get.php${q}`),
          fetch(`${urlBase}/payment-pixqrcode.php${q}`)
        ])

        const payData = await resPay.json()
        if (!resPay.ok) throw new Error(payData.error || 'Erro ao carregar pagamento')
        setPayment(payData)

        const pixData = await resPix.json()
        if (resPix.ok) setPix(pixData)

      } catch (e) {
        setErro(e.message || 'Erro inesperado')
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [currentWorkspace?.id, paymentId])

  if (loading) return <div style={{ padding: 24 }}>Carregando...</div>
  if (erro) return <div style={{ padding: 24, color: '#dc2626' }}>{erro}</div>
  if (!payment) return <div style={{ padding: 24 }}>Não encontrado</div>

  const valor = payment.value
  const dueDate = payment.dueDate
  const status = payment.status
  const invoiceUrl = payment.invoiceUrl

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Detalhes da Fatura</h2>
        {invoiceUrl && (
          <a href={invoiceUrl} target="_blank" rel="noreferrer" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: '#111827', color: 'white', padding: '8px 12px', borderRadius: 8, textDecoration: 'none'
          }}>
            <Icon icon="mdi:external-link" /> Ver no Asaas
          </a>
        )}
      </div>

      <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16 }}>
          <div style={{ color: '#6b7280', fontSize: 12 }}>Status</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{status}</div>
        </div>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16 }}>
          <div style={{ color: '#6b7280', fontSize: 12 }}>Valor</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>R$ {parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
        </div>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16 }}>
          <div style={{ color: '#6b7280', fontSize: 12 }}>Vencimento</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{new Date(dueDate + 'T00:00:00').toLocaleDateString('pt-BR')}</div>
        </div>
      </div>

      <div style={{ marginTop: 24, background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16 }}>
        <h3 style={{ margin: '0 0 12px' }}>Pagamento via PIX</h3>
        {pix?.payload ? (
          <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
            <div style={{ width: 200, height: 200, background: '#f3f4f6', borderRadius: 8, border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(pix.payload)}`} alt="QR Code PIX" style={{ width: '100%', height: '100%', borderRadius: 7 }} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, color: '#6b7280' }}>Pix copia e cola</div>
              <div style={{ marginTop: 8, padding: 12, background: '#f9fafb', borderRadius: 8, fontFamily: 'monospace', fontSize: 12, color: '#374151', wordBreak: 'break-all' }}>{pix.payload}</div>
            </div>
          </div>
        ) : (
          <div style={{ color: '#6b7280' }}>QR Code PIX não disponível para esta cobrança.</div>
        )}
      </div>
    </div>
  )
}

